import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

const TitleStyles = css`
  line-height: 24px;
  font-size: 20px;
  font-weight: bold;
`;

export const MessagingWrapper = styled.div`
  padding: 21px 0;
  @media only screen and (max-width: 767px) {
    padding: 0;
  }
`;

export const MarinaTitleWrapper = styled.div`
  padding: 13px 25px;
  background-color: ${themeGet('text.0', '#2c2c2c')};
  @media only screen and (max-width: 480px) {
    padding: 13px 21px 13px 25px;
  }
  @media only screen and (max-width: 413px) {
    padding: 8px 12px 8px 25px;
  }
  .link {
    color: ${themeGet('color.1', '#ffffff')};
    display: flex;
    align-items: center;
    font-size: 22px;
  }
`;

export const MarinaTitle = styled.h3`
  ${TitleStyles};
  color: ${themeGet('color.1', '#ffffff')};
  margin-bottom: 0;
  margin-left: 5px;
  @media only screen and (max-width: 413px) {
    font-size: 16px;
  }
`;

export const Sidebar = styled.aside`
  height: calc(100vh - 105px);
  position: relative;
  background-color: ${themeGet('color.1', '#ffffff')};
  box-shadow: 0 3px 6px ${themeGet('boxShadow.1', 'rgba(26, 68, 116, 0.16)')};
  header {
    display: none;
  }
  @media only screen and (max-width: 991px) {
    height: calc(100vh - 125px);
  }
`;

export const SidebarScrollInner = styled.div`
  position: absolute;
  overflow: hidden;
  max-height: 100%;
  width: 100%;
`;

export const SidebarHeader = styled.div`
  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

export const MarinaDetails = styled.div`
  padding: 16px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 13px 15px;
  background-color: ${themeGet('color.22', '#fafafa')};
  margin-bottom: 8px;
  color: ${themeGet('text.3', '#8d8d8d')};
`;

export const InfoLabel = styled.div`
  display: flex;
  align-items: center;
  margin-right: 10px;
  span {
    margin-left: 13px;
    white-space: nowrap;
  }
`;

export const Info = styled.div`
  text-align: right;
  a {
    color: ${themeGet('primary.0', '#194AB9')};
    &:hover {
      opacity: 0.8;
    }
  }
`;

export const AssociationInfo = styled.div`
  margin-top: 20px;
  padding-left: 8px;
`;

export const AssociationTitle = styled.h4`
  font-size: 20px;
  font-weight: bold;
  color: ${themeGet('text.4', '#323232')};
  margin-bottom: 6px;
`;

export const AssociationCard = styled.div`
  margin-bottom: 4px;
  img {
    max-width: 55px;
  }
`;

export const AssociationName = styled.p`
  font-size: 15px;
  font-weight: bold;
  color: ${themeGet('text.3', '#8d8d8d')};
`;
